<template lang="html">
  <Layout currentMenu="Notifications">
    <LoadingSection
      title="Notifications"
      :loading="loading"
      :autoPadding="false"
    >
      <template v-slot:content>
        <div class="section-field flex-box wrap">
          <h3 class="black pull-left bgap-24">Symbium Newsletter</h3>
          <div class="right pull-right">
            <div class="bgap-16" id="notification-dropdown"></div>
            <SymbiumButton
              text="Save"
              :onClick="submitData"
              :loading="submitting"
              :isDisabled="notAllowed"
              buttonSize="noti-button-size"
            />
          </div>
        </div>
      </template>
    </LoadingSection>
    <AlertSuccessModal :title="alertMessage" />
  </Layout>
</template>

<script>
import EventBus from 'src/components/EventBus.js'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import AlertSuccessModal from 'src/components/common/modals/AlertSuccessModal.vue'

export default {
  components: { SymbiumButton, LoadingSection, Layout, AlertSuccessModal },
  data() {
    return {
      submitting: false,
      loading: true,
      notifications: undefined,
      dirty: false,
      alertMessage: '',
      firstFetchData: true,
      previousNotifications: undefined,
    }
  },
  methods: {
    submitData() {
      this.submitting = true;
      this.$user.submitUserUpdate({
        notifications: this.notifications,
      })
    },
    assignUserData(data) {
      this.notifications = data.notifications;
      this.previousNotifications = data.notifications;
      this.loading = false;
      this.loadDropdown();
    },
    afterSubmittedSucessfully() {
      this.submitting = false;
      this.dirty = false;
      this.alertMessage = "Notifications updated";

      this.$modal.show('alert-success-modal')
    },
    onNewsletterChange(value) {
      this.notifications = value
      this.dirty = value !== this.previousNotifications ? true : false
    },
    loadDropdown() {
      if (!this.firstFetchData) return;
      this.firstFetchData = false

      window.notificationVueComponent = this
      // Create dropdown
      this.$nextTick(() => {
        const selectedIndex = this.notifications === 'subscribed' ? 1 : 2
        const customDropdownScript = document.createElement('script')

        customDropdownScript.text = `
          new MultiDropdown({
            id: "notification-dropdown",
            options: [
              { id: "subscribed", option: "Subscribed" },
              { id: "unsubscribed", option: "Unsubscribed" },
            ],
            selectOption: (value) => window.notificationVueComponent.onNewsletterChange(value.id),
            isMulti: false,
            defaultValueIndex: ${selectedIndex}
          });`
        document.head.appendChild(customDropdownScript)
      })
    }
  },
  computed: {
    notAllowed() {
      return !this.dirty;
    },
  },
  created() {
    EventBus.$on('data-submitted-sucessfully', this.afterSubmittedSucessfully)
    EventBus.$on('user-fetched', this.assignUserData)
  },
  beforeDestroy() {
    EventBus.$off('data-submiited-sucessfully', this.afterSubmittedSucessfully)
    EventBus.$off('user-fetched', this.assignUserData)
  },
  mounted() {
    this.$user.fetchMe()
  },
}
</script>

<style lang="scss">
.noti-button-size {
  width: calc(min(290px, 95vw));
}

#notification-dropdown {
  width: fit-content;
  
  .select-items,
  .selected-item,
  .select-selected {
    width: 290px !important;
  }
}
</style>
